import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidLinkedinIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20.47 2H3.53a1.45 1.45 0 0 0-1.47 1.43v17.14A1.45 1.45 0 0 0 3.53 22h16.94a1.4494 1.4494 0 0 0 1.0312-.4105A1.4506 1.4506 0 0 0 21.94 20.57V3.43a1.4496 1.4496 0 0 0-.9136-1.3273A1.4498 1.4498 0 0 0 20.47 2ZM8.09 18.74h-3v-9h3v9ZM6.59 8.48a1.56 1.56 0 0 1 0-3.12 1.5699 1.5699 0 1 1 0 3.12Zm12.32 10.26h-3v-4.83c0-1.21-.43-2-1.52-2A1.6505 1.6505 0 0 0 12.85 13a1.9982 1.9982 0 0 0-.1.73v5h-3v-9h3V11a2.9998 2.9998 0 0 1 2.71-1.5c2 0 3.45 1.29 3.45 4.06v5.18Z"/>
  </SvgIcon>
}

export default SolidLinkedinIcon
